export default "__VITE_ASSET__7uNGCwZG__"